import { render, staticRenderFns } from "./recommendations.vue?vue&type=template&id=78793556"
import script from "./recommendations.vue?vue&type=script&lang=js"
export * from "./recommendations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ThumbnailCourse: require('/usr/src/app/components/thumbnail/course.vue').default})
